import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AppBar, Box, Button, IconButton, Toolbar, Tooltip, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '../../../asset/icons/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import SearchIcon from '@mui/icons-material/Search';
import AccountPopover from '../AccountPopover/AccountPopover';
import ActivityCenterPopover from '../../Popovers/ActivityCenterPopover/ActivityCenterPopover';
// import ContentSearch from "./ContentSearch";
import ThemeIcon from '../ThemeIcon';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import LanguagePopover from '../LanguagePopover';
// import NotificationPopover from '../../Popovers/NotificationPopover/NotificationPopover';
import FavouritePopover from '../FavouritePopover/FavouritePopover';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import AnnouncementApi from '../../../services/api/AnnouncementsApi';
import IF from '../../ui/IF';
import SearchDialogLayout from '../SearchDialogLayout/SearchDialogLayout';
import GlobalFilterPopover from '../../Popovers/GlobalFilterPopover/GlobalFilterPopover';

export const openDrawerWidth = 270;
export const closeDrawerWidth = 80;
export const navBarHeight = 64;
export const drawerWidth = 270;

const NavbarRoot = styled(AppBar)(({ theme, open }) => ({
  ...(theme.palette.mode === 'light' && {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    // boxShadow: "none",
    // boxShadow: theme.shadows,
    boxShadow: 'rgba(37, 74, 135, 0.13) 0px 0px 28px 0px',

    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    // borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  backgroundColor: theme.palette.background.paper,
  boxShadow: open ? 'rgba(37, 74, 135, 0.13) 0px 0px 28px 0px' : 'none',
  zIndex: theme.zIndex.drawer,
  width: '100%', // Set width to 100% by default
  [theme.breakpoints.up('lg')]: {
    marginLeft: open ? openDrawerWidth : closeDrawerWidth,
    width: `calc(100% - ${open ? openDrawerWidth : closeDrawerWidth}px)`, // Adjust width based on sidebar open/close
  },
  // In mobile mode, when the sidebar is closed, set width to 100%
  [theme.breakpoints.down('lg')]: {
    width: open ? `calc(100% - ${openDrawerWidth}px)` : '100%',
  },
}));

// const INITIAL_PAGE_NUM = 1;
// const PAGE_SIZE = 10;

const showSearchDialog = false;

const Navbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const { open } = props;
  // const anchorEl = useRef(null);
  const theme = useTheme();
  const { t } = useTranslation();

  // const [openPopover, setOpenPopover] = useState(false);
  // const [isSearching, setIsSearching] = useState(false);
  // const [totalCount, setTotalCount] = useState(0);
  // const [showInfiniteLoader, setShowInfiniteLoader] = useState(true);
  // const [announcementList, setAnnouncementList] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const menuBarIcon = (
    <IconButton color="primary" onClick={onSidebarMobileOpen}>
      {open && <Tooltip title={t('Tooltip_Navigate')}><MenuOpenIcon sx={{ fontSize: 34 }} /></Tooltip>}
      {!open && <Tooltip title={t('Tooltip_Navigate')}><MenuIcon sx={{ fontSize: 32 }} /></Tooltip>}
      {/* <MenuIcon fontSize="medium" /> */}
    </IconButton>
  );

  // const handleOpen = () => {
  //   setOpenPopover(true);
  // };

  const toggleSearchDialog = () => {
    setOpenDialog((prevVal) => !prevVal);
  };

  // const queryClient = new QueryClient({
  //   defaultOptions: {
  //     queries: {
  //       refetchOnWindowFocus: false,
  //       // keepPreviousData: true,
  //       refetchOnMount: false,
  //       refetchOnReconnect: false,
  //     },
  //   },
  // });

  // const fetchAnnouncementList = useCallback(async (pageNum) => {
  //   if (pageNum === INITIAL_PAGE_NUM) {
  //     setIsSearching(true);
  //   }

  //   try {
  //     const response = await AnnouncementApi.searchAnnouncementsForNotification({
  //       page: pageNum,
  //       pageSize: PAGE_SIZE,
  //       sortBy: 'CreatedOnDescending',
  //     });
  //     if (response?.Data) {
  //       setTotalCount(response?.Count);
  //       setAnnouncementList(response?.Data);
  //     }
  //     setIsSearching(false);
  //     setShowInfiniteLoader(false);
  //   } catch (err) {
  //     setShowInfiniteLoader(false);
  //     setIsSearching(false);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchAnnouncementList();
  // }, [fetchAnnouncementList]);

  return (
    <>
      <NavbarRoot {...other}>
        <Toolbar sx={{ minHeight: navBarHeight }}>
          {menuBarIcon}
          <Box
            sx={{
              flexGrow: 1,
              ml: 2,
            }}
          />

          <IF condition={showSearchDialog}>
            <Button
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '4px 8px',
                backgroundColor: 'background.paper',
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: '10px',
              }}
              startIcon={<SearchIcon />}
              onClick={toggleSearchDialog}
            >
              <Typography color="textPrimary" mx={1}>
                {`${t('Label_Search')}...`}
              </Typography>
              <Box
                sx={{
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  lineHeight: '20px',
                  marginLeft: '8px',
                  border: `1px solid ${theme.palette.divider}`,
                  backgroundColor: 'background.default',
                  padding: '0px 4px',
                  borderRadius: '7px'
                }}
              >
                <Typography variant="button" color="textPrimary" mx={0.25} p={0}>
                  Ctrl+K
                </Typography>

              </Box>
            </Button>
          </IF>

          <Box sx={{ ml: 1 }}>
            <GlobalFilterPopover />
          </Box>
          <LanguagePopover />
          <Box sx={{ ml: 1 }}>
            <ActivityCenterPopover />
          </Box>
          <Box sx={{ ml: 1 }}>
            <FavouritePopover />
          </Box>
          {/* <Box sx={{ ml: 1 }}>
          <ContentSearch />
        </Box> */}

          {/* <Box sx={{ ml: 1 }}>
            <IconButton
              onClick={handleOpen}
              ref={anchorEl}
            >
              {openPopover ? <NotificationsIcon fontSize="medium" color="primary" />
                : <NotificationsNoneIcon fontSize="medium" />}
            </IconButton>
            {openPopover && (
            <QueryClientProvider client={queryClient}>
              <NotificationPopover
                anchorRef={anchorEl}
                open={openPopover}
                setOpen={setOpenPopover}
                isSearching={isSearching}
                showInfiniteLoader={showInfiniteLoader}
                announcementList={announcementList || []}
                fetchAnnouncementList={fetchAnnouncementList}
                totalCount={totalCount}
                setShowInfiniteLoader={setShowInfiniteLoader}
              />
            </QueryClientProvider>
            )}
          </Box> */}

          <Box sx={{ ml: 0.5 }}>
            <ThemeIcon />
          </Box>

          <Box sx={{ ml: 2 }}>
            <AccountPopover />
          </Box>
        </Toolbar>
      </NavbarRoot>
      <IF condition={openDialog}>
        <SearchDialogLayout
          toggleDrawer={toggleSearchDialog}
        />
      </IF>
    </>
  );
};

Navbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default Navbar;
